// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { REG_EXP } from '~/utils/constants/common';
import { IAccountLogin } from '~/utils/mockData/common';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      username: yup
        .string()
        .trim()
        // .required(t('common_validate_field_required', { ns: 'common/base' }))
        .optional(),
      password: yup
        .string()
        .trim()
        // .required(t('common_validate_field_required', { ns: 'common/base' }))
        .optional(),
    })
    .required();
};

export const defaultValuesForm: IAccountLogin = {
  username: '',
  password: '',
};
